/* tslint:enable:no-unused-variable */

import { LeftColumn, RightColumn, StaticPage } from './StaticPage';
import { Helpdesk } from './Helpdesk';
import { Address } from './Address';
import { useParams } from 'react-router';
import { useEffect } from 'react';

export function ReceiptPage() {
    const { hash } = useParams();
    useEffect(() => {
        if (hash) {
            window.location.assign(`/ui-api/receipt/pdf/${hash}`);
        }
    }, [hash]);

    return (
        <StaticPage>
            <LeftColumn></LeftColumn>
            <RightColumn>
                <Helpdesk />
                <Address />
            </RightColumn>
        </StaticPage>
    );
}
